import { Flex, Icon, Typography } from '@nilohealth/core-ui'

import { MdOutlineArrowForward } from 'react-icons/md'
import { MetricBigNumber } from '../metrics.types'
import { ArrowIcon } from './bignumber.styles'

type BigNumberBodyProps = {
  metric: MetricBigNumber
  showDetails: boolean
}
const BigNumberBody = ({ metric, showDetails }: BigNumberBodyProps) => {
  const value =
    typeof metric.properties.value === 'number' || typeof metric.properties.value === 'bigint'
      ? new Intl.NumberFormat('pt-BR', { maximumSignificantDigits: 3 }).format(metric.properties.value)
      : metric.properties.value

  const previous = metric.properties?.previous

  const hasData = !!value

  return (
    <>
      <Typography
        type={hasData && value.length > 6 ? 'headingMedium' : 'headingXLarge'}
        weight="bold"
        align="left"
        color={!!previous && previous.arrow === 'down' ? 'errorMedium' : 'neutralLowDark'}
        truncate
        css={{ marginTop: '$nano', lineHeight: '48px', width: '100%' }}
      >
        {hasData ? value : '-'}
      </Typography>

      {!showDetails && hasData && (
        <Flex align="center">
          {!!previous?.arrow && <ArrowIcon isPositive={previous.arrow === 'up'} />}

          {!!previous?.percentageVariation && (
            <Typography
              type="subtitleXXSmall"
              weight="semibold"
              truncate
              align="left"
              color={previous?.arrow === 'down' ? 'errorMedium' : 'successPure'}
            >
              {previous.percentageVariation}%
            </Typography>
          )}
        </Flex>
      )}

      {!showDetails && hasData && previous && !!previous.value && !!previous.description && (
        <Typography type="subtitleXXSmall" weight="regular" color="neutralLowMedium" align="left" truncate>
          {`${previous.value} ${previous.description}`}
        </Typography>
      )}

      {!showDetails && !hasData && (
        <Flex css={{ marginTop: '$xxxsmall' }}>
          <Typography type="subtitleXXSmall" weight="regular" color="neutralLowMedium" align="left" truncate>
            Dados insuficientes
          </Typography>
        </Flex>
      )}

      {showDetails && (
        <Flex className="details-tag" gap="none" align="center" css={{ marginTop: '$xxxsmall' }}>
          <Typography type="captionTag" weight="semibold" color="primaryMedium" align="left" truncate>
            Ver detalhes
          </Typography>

          <Icon icon={MdOutlineArrowForward} size="small" color="primaryMedium" />
        </Flex>
      )}
    </>
  )
}

export default BigNumberBody
